// extracted by mini-css-extract-plugin
module.exports = {"pressKit":"press-kit-module--pressKit--2v6o3"};